import { render, staticRenderFns } from "./marvellous.vue?vue&type=template&id=01e623fb&scoped=true&"
import script from "./marvellous.vue?vue&type=script&lang=js&"
export * from "./marvellous.vue?vue&type=script&lang=js&"
import style0 from "./marvellous.vue?vue&type=style&index=0&id=01e623fb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e623fb",
  null
  
)

export default component.exports